import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerBusinessService } from 'src/app/core/business/customer/customer-business.service';
import { AppointmentDTO } from 'src/app/domain/customer/appointment.dto';
import { CustomerDTO } from 'src/app/domain/customer/customer.dto';
import { CustomerInput } from 'src/app/core/models/customer/customer-input';
import { CustomerDetailsDTO } from 'src/app/domain/customer/customer-details.dto';

@Injectable({
  providedIn: 'root'
})
export class CustomerFacadeService {

  constructor(private customerBusinessService: CustomerBusinessService ) { }

//to get customerList with pagination
  getCustomerListPagination(paramsReq:object):Observable<CustomerDTO>{
    return this.customerBusinessService.getCustomerListPagination(paramsReq);
  }

//to get appointlist with pagination
  getAppointmentListWithPagination(paramsReq:object):Observable<AppointmentDTO>{
    return this.customerBusinessService.getAppointmentListWithPagination(paramsReq);
  }

  
  addCustomer(data:any):Observable<any>{
    return this.customerBusinessService.addCustomer(data);
  }

  updateCustomer(data:any):Observable<any>{
    return this.customerBusinessService.updateCustomer(data);
  }

  getCustomer(paramsReq:object):Observable<CustomerDetailsDTO>{
    return this.customerBusinessService.getCustomer(paramsReq);
  }

  sendPosterToCus(data: any): Observable<any> {
    return this.customerBusinessService.sendPosterToCus(data);
  }
}
